'use client';

/** Thematic illustration for 404 - a lost casino map with a worried lucky chip. */
export function NotFoundIllustration({ className = '' }: { className?: string }) {
  return (
    <div className={`relative h-64 w-full sm:h-80 ${className}`} aria-hidden>
      <svg
        viewBox="0 0 420 280"
        fill="none"
        className="h-full w-full"
      >
        <defs>
          <linearGradient id="not-found-map" x1="95" y1="42" x2="328" y2="238" gradientUnits="userSpaceOnUse">
            <stop stopColor="#fff7ed" />
            <stop offset="1" stopColor="#fecdd3" />
          </linearGradient>
          <linearGradient id="not-found-chip" x1="121" y1="80" x2="283" y2="221" gradientUnits="userSpaceOnUse">
            <stop stopColor="#ffb74d" />
            <stop offset="1" stopColor="#e11d48" />
          </linearGradient>
          <filter id="not-found-shadow" x="34" y="8" width="346" height="264" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feDropShadow dx="0" dy="22" stdDeviation="18" floodColor="#000000" floodOpacity="0.28" />
          </filter>
        </defs>

        <ellipse cx="211" cy="232" rx="142" ry="24" fill="#020617" opacity="0.32" />
        <circle cx="82" cy="50" r="12" fill="#fb7185" opacity="0.65" />
        <circle cx="352" cy="82" r="9" fill="#ffb74d" opacity="0.7" />
        <path d="M54 184C84 164 102 164 132 184C162 204 181 204 210 184C241 164 260 164 291 184C322 204 341 204 372 184" stroke="#334155" strokeWidth="3" strokeLinecap="round" strokeDasharray="7 13" opacity="0.42" />

        <g filter="url(#not-found-shadow)">
          <path d="M91 54L153 70L209 54L271 70L329 55V215L270 231L209 215L151 231L91 215V54Z" fill="url(#not-found-map)" />
          <path d="M153 70V231M209 54V215M271 70V231" stroke="#fb7185" strokeWidth="2" opacity="0.38" />
          <path d="M117 105C151 96 172 104 190 130C211 162 248 170 298 146" stroke="#881337" strokeWidth="5" strokeLinecap="round" strokeDasharray="12 13" opacity="0.72" />
          <path d="M300 126L324 141L300 158L309 142L300 126Z" fill="#881337" />
          <circle cx="116" cy="106" r="10" fill="#e11d48" />
          <circle cx="298" cy="146" r="10" fill="#2563eb" />
        </g>

        <g transform="translate(144 91)">
          <circle cx="68" cy="68" r="62" fill="url(#not-found-chip)" stroke="#fff7ed" strokeWidth="8" />
          <circle cx="68" cy="68" r="43" fill="#111827" stroke="rgba(255,255,255,0.3)" strokeWidth="2" />
          <path d="M68 12V31M68 105V124M12 68H31M105 68H124M28 28L42 42M94 94L108 108M108 28L94 42M42 94L28 108" stroke="#fff7ed" strokeWidth="7" strokeLinecap="round" opacity="0.92" />
          <path d="M48 60C54 54 60 54 66 60M71 60C77 54 83 54 89 60" stroke="#fff7ed" strokeWidth="5" strokeLinecap="round" />
          <path d="M50 84C61 75 76 75 87 84" stroke="#fff7ed" strokeWidth="5" strokeLinecap="round" />
          <text x="68" y="53" fill="#fff7ed" fontSize="24" fontWeight="800" textAnchor="middle">404</text>
        </g>
      </svg>
    </div>
  );
}

/** Thematic illustration for error page - warning/exclamation with chip */
export function ErrorIllustration({ className = '' }: { className?: string }) {
  return (
    <div className={`relative h-40 w-full sm:h-48 ${className}`} aria-hidden>
      <svg
        viewBox="0 0 200 140"
        fill="none"
        className="h-full w-full"
      >
        {/* Soft background */}
        <ellipse cx="100" cy="90" rx="70" ry="25" fill="rgba(239,68,68,0.06)" />
        {/* Casino chip with exclamation */}
        <g transform="translate(100, 65)">
          <circle cx="0" cy="0" r="48" fill="#1e2235" stroke="rgba(255,183,77,0.4)" strokeWidth="3" />
          <circle cx="0" cy="0" r="40" fill="#15192b" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
          <circle cx="0" cy="0" r="32" fill="#1e2235" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
          {/* Exclamation mark */}
          <rect x="-4" y="-28" width="8" height="32" rx="2" fill="#ffb74d" />
          <circle cx="0" cy="18" r="6" fill="#ffb74d" />
        </g>
      </svg>
    </div>
  );
}
